import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'
import { queryString } from '../../utils/queryString'

const cardCategorySlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    cardCategory: build.query<
      any,
      { page?: number; limit?: number; name?: string }
    >({
      query: ({ page = 1, limit, name = '' }) => {
        const qs = queryString({ page, limit, name })

        return `${urlConfig.productsBaseUrl}/products/categories?${qs}&sort=asc`
      },
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Categories' as const,
                id: _id,
              })),
              { type: 'Categories', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Categories', id: 'PARTIAL-LIST' }],
    }),
  }),
})

export const { useCardCategoryQuery } = cardCategorySlice
